import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthProvider';

// Route protégée — redirige vers login si non connecté
function ProtectedRoute({ children }) {
    const { isLoggedIn } = useAuth();

    if (!isLoggedIn) {
        return <Navigate to="/login" />;
    }

    return children;
}

export default ProtectedRoute;